var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateProject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5L11.8845 5.26892C11.5634 4.6268 11.4029 4.30573 11.1634 4.07116C10.9516 3.86373 10.6963 3.70597 10.4161 3.60931C10.0992 3.5 9.74021 3.5 9.02229 3.5H5.2C4.0799 3.5 3.51984 3.5 3.09202 3.71799C2.71569 3.90973 2.40973 4.21569 2.21799 4.59202C2 5.01984 2 5.5799 2 6.7V7.5M2 7.5H17.2C18.8802 7.5 19.7202 7.5 20.362 7.82698C20.9265 8.1146 21.3854 8.57354 21.673 9.13803C22 9.77976 22 10.6198 22 12.3V16.7C22 18.3802 22 19.2202 21.673 19.862C21.3854 20.4265 20.9265 20.8854 20.362 21.173C19.7202 21.5 18.8802 21.5 17.2 21.5H6.8C5.11984 21.5 4.27976 21.5 3.63803 21.173C3.07354 20.8854 2.6146 20.4265 2.32698 19.862C2 19.2202 2 18.3802 2 16.7V7.5Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProject);
export default __webpack_public_path__ + "static/media/createProject.113ab2a6795ce988d5e8b46ae568d716.svg";
export { ForwardRef as ReactComponent };